import qs from "qs"

export default {
    methods: {
        convertStringNumbers(obj) {
            return Object.keys(obj).reduce((acc, key) => {
                const value = Array.isArray(obj[key]) ? obj[key] : [obj[key]]
                acc[key] = value.map(item => typeof item === 'string' && !isNaN(item) ? Number(item) : item)
                return acc
            }, {})
        },

        flattenObjectToQueryParams(obj, parentKey = '') {
            let queryParams = {}

            for (let [key, value] of Object.entries(obj)) {
                let queryKey = parentKey ? `${parentKey}[${key}]` : key

                if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                    Object.assign(queryParams, this.flattenObjectToQueryParams(value, queryKey))
                } else {
                    queryParams[queryKey] = value
                }
            }

            return queryParams
        },

        async toHistory(query) {
            const currentQuery = qs.parse(this.$route.query)

            const newQuery = this.flattenObjectToQueryParams({
                ...currentQuery,
                ...query
            })

            await this.$router.push({query: newQuery}).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err
                }
            })
        },

        getHistory() {
            return qs.parse(this.$route.query)
        },
    }
}
